import { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { AppDispatch } from 'src/utils/AppDispatch'
import { generatePath, useParams, useLocation } from 'react-router'
import { useHistory } from 'react-router-dom'
import * as ROUTES from 'src/constants/Routes'
import LoaderWrapper from '@flatsy/core/Loader/Wrapper'
import { updateApplicationInterest } from 'src/redux/slices/Application/Action'
import { applicationSlice } from 'src/redux/slices/Application'

const useQuery = () => new URLSearchParams(useLocation().search)

const PostInterest: React.FC = () => {
  const { applicationId, interest } = useParams<{ applicationId: string; interest: string }>()
  const queryString = useQuery()
  const getIsInterest = queryString.get('interest')
  const [loading, setLoading] = useState(false)
  const history = useHistory()
  const dispatch: AppDispatch = useDispatch()
  const isInterest = getIsInterest === 'true'

  const redirectIfInterested = () => {
    history.push(
      generatePath(ROUTES.APPLICATION_BOOKING, {
        applicationId,
      })
    )
  }

  useEffect(() => {
    setLoading(true)
    dispatch(
      updateApplicationInterest({
        applicationId,
        interest: isInterest,
      })
    )
      .then(() => {
        setLoading(false)
        if (isInterest) {
          redirectIfInterested()
          dispatch(applicationSlice.actions.setPostBookingInterestFromMailToTrue())
        } else {
          history.push(
            generatePath(ROUTES.APPLICATION_DOSSIER_CANCEL, {
              applicationId,
            })
          )
        }
      })
      .catch(() => {
        setLoading(false)
      })
  }, [applicationId, interest])

  return <>{loading && <LoaderWrapper absolute />}</>
}
export default PostInterest
